var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "full-height" }, [
    _c("div", { class: _vm.isAma ? "starter-kit-ama" : "starter-kit" }, [
      _c("div", { staticClass: "kit-name" }, [
        _c("span", [_vm._v(_vm._s(_vm.label))])
      ]),
      _c(
        "button",
        {
          staticClass: "btn btn-primary add-to-basket-btn cursor-pointer",
          attrs: { disabled: _vm.addedToBasket },
          on: {
            click: function($event) {
              return _vm.addKitToBasket(_vm.name)
            }
          }
        },
        [
          _vm.addedToBasket
            ? _c("span", [_vm._v(_vm._s(_vm.$t("addedToBasket")))])
            : _c("span", [_vm._v(_vm._s(_vm.$t("addToBasket")))])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }